import { CampaignResponse } from './models/Campaign/CampaignResponse.model';
import { TimeWindowsResponse } from './models/TechnicalCoordination/TimeWindowsResponse.model';
import { TimeWindowDate } from './models/TechnicalCoordination/TimeWindowDate.model';
import { TechnicanHours } from './models/TechnicalCoordination/TechnicanHours.model';
export const GetMock = (mockType: string): any => {
  switch (mockType) {
    case 'LoadCampaign': {
      const res: CampaignResponse = {
        Price1: '69.00',
        Price2: '99.00',
        PricePeriod1: '1-12',
        PricePeriod2: '13-36',
        Titile: 'Top15',
        UpSpeed: '0.01-0.8',
        DownSpeed: '7.5-15',
        InstallPrice: '50',
        Supplier: ' בזק בינלאומי ',
        CampaignCode: 'CAMP2449',
        ProcessID: 'f70bdfca-2cb5-47ba-9ac9-a57be8044d7a',
        IsSuccessful: true,
        ErrorCode: '',
        ErrorMessage: '',
        ProcessState: 'SHOW_CAMPAIGN'
      };
      return res;
    }
    case 'LoadCampaignAlternative': {
      const res: CampaignResponse = {
        Price1: '55.00',
        Price2: '89.00',
        PricePeriod1: '1-12',
        PricePeriod2: '13-36',
        Titile: 'Top15',
        UpSpeed: null,
        DownSpeed: '0.01-0.8',
        InstallPrice: '50',
        Supplier: ' בזק בינלאומי ',
        CampaignCode: 'CAMP2448',
        ProcessID: 'f70bdfca-2cb5-47ba-9ac9-a57be8044d7a',
        IsSuccessful: true,
        ErrorCode: '',
        ErrorMessage: '',
        ProcessState: 'SHOW_CAMPAIGN'
      };
      return res;
    }
    case 'LoadTimeWindows': {
      const TimeWindows: TimeWindowsResponse = {
        IsSuccessful: true,
        TimeWindows:  new Array<TimeWindowDate>({
          Date: getDatePlusDays(1),
          DateString: getDatePlusDaysStringFormat(1),
          Weekday: 3,
          Hours: getHours()
        }, {
          Date: getDatePlusDays(2),
          DateString: getDatePlusDaysStringFormat(2),
          Weekday: 3,
          Hours: getHours()
        }, {
          Date: getDatePlusDays(3),
          DateString: getDatePlusDaysStringFormat(3),
          Weekday: 3,
          Hours: getHours()
        }, {
          Date: getDatePlusDays(4),
          DateString: getDatePlusDaysStringFormat(4),
          Weekday: 3,
          Hours: getHours()
        }, {
          Date: getDatePlusDays(5),
          DateString: getDatePlusDaysStringFormat(5),
          Weekday: 3,
          Hours: getHours()
        }, {
          Date: getDatePlusDays(6),
          DateString: getDatePlusDaysStringFormat(6),
          Weekday: 3,
          Hours: getHours()
        })
      };
      return TimeWindows;
    }
  }
};

function getDatePlusDays(plusDays: number): Date {
  return new Date(new Date().setDate(new Date().getDate() + plusDays));
}

function getDatePlusDaysStringFormat(plusDays: number): string {
  const date = getDatePlusDays(plusDays);
  return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
}

function getHours(): Array<TechnicanHours> {
  return new Array<TechnicanHours>({
    From: '08:00',
    To: '10:00'
  }, {
    From: '10:00',
    To: '12:00'
  }, {
    From: '12:00',
    To: '14:00'
  }, {
    From: '14:00',
    To: '16:00'
  }, {
    From: '16:00',
    To: '18:00'
  });
}
